<!--  -->
<template>
    <div class='container'>
        <div class="map_wrapper box box_v">
            <div class="number_wrapper box box_between">
                <div class="numberbg box_f1">
                    <div class="title">总事件数</div>
                    <div class="subtitle" v-if="totalCount">{{totalCount}}<span style="font-size:13px">件</span></div>
                </div>
                <div class="numberbg box_f1">
                    <div class="title">待处理</div>
                    <div class="subtitle" v-if="unfinishedCount">{{unfinishedCount}}<span style="font-size:13px">件</span></div>
                </div>
                <div class="numberbg box_f1">
                    <div class="title">已处理</div>
                    <div class="subtitle"  v-if="finishedCount">{{finishedCount}}<span style="font-size:13px">件</span></div>
                </div>
                <div class="numberbg box_f1">
                    <div class="title">已公示</div>
                    <div class="subtitle">
                        <div class="subtitle" v-if="showCount">{{showCount}}<span style="font-size:13px">件</span></div>
                    </div>
                </div>
            </div>
            <div id="eventmap" class="map box_f1"></div>
        </div>
        
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
var map = null
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            totalCount:0,
            finishedCount:0,
            unfinishedCount:0,
            showCount:0,
            /**地图 */
            //map:null,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.monitor_eventTotal).then(res=>{
                this.totalCount = res.rows[0].totalCount  //总事项数
                this.finishedCount = res.rows[0].finishedCount //已处理
                this.unfinishedCount = res.rows[0].unfinishedCount   //未处理
                this.showCount = res.rows[0].showCount  //用户数

            }).catch(e=>console.log(e))
        },
        getHotData(){
            this.$get(this.urlobj.monitor_event_hotmap).then(res=>{
               let heatmapData = res.rows.map(item=>{
                   return {
                       "lng": parseFloat(item.longitude), 
                       "lat": parseFloat(item.latitude), 
                       "count": parseInt(item.count)
                   }
               })
                 let heatmapOpts = {
                      gradient: {
                            0.5: '#2c7bb6',
                            0.65: '#abd9e9',
                            0.7: '#ffffbf',
                            0.9: '#fde468',
                            1.0: '#d7191c'
                        },
                    //3d 相关的参数
                    '3d': {
                        //热度转高度的曲线控制参数，可以利用左侧的控制面板获取
                        heightBezier: [0.4, 0.2, 0.4, 0.8],
                        //取样精度，值越小，曲面效果越精细，但同时性能消耗越大
                        gridSize: 2,
                        heightScale: 1,
                        // gradient:{
                        //     0.4:'rgb(0, 255, 255)',
                        //     0.65:'rgb(0, 110, 255)',
                        //     0.85:'rgb(100, 0, 255)',
                        //     1.0:'rgb(100, 0, 255)'
                        // }
                        
                    }
                };

                //初始化heatmap对象
                let heatmap = new AMap.Heatmap(map, heatmapOpts);

                heatmap.setDataSet({
                    data: heatmapData,
                    max:100,
                });

            }).catch(e=>console.log(e))
        },
        initMap(){
            let that = this
            console.log('here')
            map = new AMap.Map('eventmap', {
                viewMode: '3D',
                pitch: 55,
                zoom: 9,
                rotation:15,
                center:[115.427802,35.807792],
                mapStyle: "amap://styles/0dd55e5d7d8ea7df349126652ba128bf",
                showLabel: false,
                skyColor:'#1f2764'
                //center: [115.041299,35.768234]
            });
            // 设置光照
            // map.AmbientLight = new AMap.Lights.AmbientLight([1, 1, 1], 0.5);
            //map.DirectionLight = new AMap.Lights.DirectionLight([0, 0, 1], [1, 1, 1], 1);

            var object3Dlayer = new AMap.Object3DLayer();
            map.add(object3Dlayer);

            new AMap.DistrictSearch({
                subdistrict: 0,   //返回下一级行政区
                extensions: 'all',  //返回行政区边界坐标组等具体信息
                level: 'city'  //查询行政级别为 市center
            }).search("濮阳市", function (status, result) {
                console.log(result.districtList[0].center)
                var bounds = result.districtList[0].boundaries;
                
                var prism = new AMap.Object3D.Prism({
                    path: bounds,
                    height: 30000,
                    color: 'rgba(0, 24, 55, 0.5)' // 支持 #RRGGBB、rgb()、rgba() 格式数据
                });

                prism.transparent = true;
                object3Dlayer.add(prism);


                var wall = new AMap.Object3D.Wall({
                    path:bounds,
                    height:30000,
                    color:'#ffffff'
                });
                wall.backOrFront = 'both';
                wall.transparent = true;
                object3Dlayer.add(wall)

            
            });

            this.getHotData()

        },
        initMap2(){
            var opts = {
        subdistrict: 0,
        extensions: 'all',
        level: 'city'
    };
    //利用行政区查询获取边界构建mask路径
    //也可以直接通过经纬度构建mask路径
    var district = new AMap.DistrictSearch(opts);
    district.search('濮阳市', function(status, result) {
        var bounds = result.districtList[0].boundaries;
        var mask = []
        for(var i =0;i<bounds.length;i+=1){
            mask.push([bounds[i]])
        }
        var map = new AMap.Map('eventmap', {
            mask:mask,
            center:[115.427802,35.807792],
            disableSocket:true,
            viewMode:'3D',
            showLabel:false,
            labelzIndex:130,
            pitch:55,
          rotation:15,
            zoom:9,
             mapStyle: "amap://styles/0dd55e5d7d8ea7df349126652ba128bf",
             skyColor:'#1f2764'
            //layers:[
                //new AMap.TileLayer.RoadNet({
                    //rejectMapMask:true
               // }),
                //new AMap.TileLayer.Satellite()
            //]
        });
        console.log('--------------------')
       console.log(map)
       console.log(AMap.Map)
        //添加高度面
        var object3Dlayer = new AMap.Object3DLayer({zIndex:1});
        map.add(object3Dlayer)
        var height = 30000;
        //var color = '#001837';//rgba
        var color = "#004BAC"
        // var wall = new AMap.Object3D.Wall({
        //     path:bounds,
        //     height:height,
        //     color:'#99ffff'
        // });
        // wall.transparent = true
        // object3Dlayer.add(wall)
        
         var prism = new AMap.Object3D.Prism({
            path:bounds,
            height:height,
            color:color
        });
        prism.transparent = true
        object3Dlayer.add(prism)
        
        //添加描边
        // for(var i =0;i<bounds.length;i+=1){
        //     new AMap.Polyline({
        //        path:bounds[i],
        //         strokeColor:'#99ffff',
        //         strokeWeight:4,
        //         map:map
        //     })
        // }
    });
        }
        
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
       
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        //
        this.getData()

        this.$nextTick(()=>{
            this.initMap()
        })
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
        console.log('销毁地图')
        map && map.destroy();
    }, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{
    width:100%;
    height:100%;
}
.map_wrapper{
    width:100%;
    height:100%;
    background-image: url('../../../../assets/images/monitorpy/9.png');
    background-size: 100% 100%;
    padding:20px;
    .number_wrapper{
        // position:absolute;
        // top:20px;
        // left:40px;
        // right:40px;
        //margin:20px 40px;
        height:88px;

        .numberbg{
            margin:0 10px;
            width:100%;
            height:100%;
            background-image: url('../../../../assets/images/monitorpy/numberbg.png');
            background-size: 100% 100%;
            
        }
        .title{
            font-size: 16px;
            color: #00EFE1;
            line-height: 45px;
            text-align: center;
        }
        .subtitle{
            font-size: 26px;
            font-style: italic;
            color: #09D4FF;
            text-align: center;
            background: linear-gradient(180deg, #00FFCC 0%, #00EAFF 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;

        }
    }
    .map{
        margin-top: 20px;
        width: 100%;
        height: 100%;
       
    }
}

</style>